import { PASSCODE_SESSION_KEY } from '@/constants';

export default function removeLocalStorage() {
  localStorage.removeItem('token');
  localStorage.removeItem('tokenExpiry');
  localStorage.removeItem('lastRefreshTime');
  localStorage.removeItem('lastRefreshAttempt');
  localStorage.removeItem('permissions');
  localStorage.removeItem('token_admin');
  localStorage.removeItem(PASSCODE_SESSION_KEY);
  removeSelectedRowsLocalStorageItems();
}

export function removeSelectedRowsLocalStorageItems() {
  localStorage.removeItem('appointments-selected-row');
  localStorage.removeItem('to-cancel-appointments-selected-row');
}
